import { Inject, Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { ASSETS_PATH } from '@anecdotes/design-system/injection-tokens';
import { Observable, shareReplay, take } from 'rxjs';

enum StorageKey {
  PrimaryAnimation = 'PrimaryAnimation',
  SecondaryAnimation = 'SecondaryAnimation',
}

@Injectable()
export class AssetsService {
  private httpClient: HttpClient;
  private assetsStorage: { [key: string]: object } = {};

  constructor(httpBackend: HttpBackend, @Inject(ASSETS_PATH) private assetsPath: string) {
    this.httpClient = new HttpClient(httpBackend);
  }

  getPrimaryLoadingAnimation(): Observable<any> {
    return this.loadAsset(StorageKey.PrimaryAnimation, 'animations/loader.json');
  }

  getSecondaryLoadingAnimation(): Observable<any> {
    return this.loadAsset(StorageKey.SecondaryAnimation, 'animations/secondary-loader.json');
  }

  private loadAsset(key: string, path: string): Observable<any> {
    if (!(key in this.assetsStorage)) {
      this.assetsStorage[key] = this.httpClient.get(`${this.assetsPath}/${path}`).pipe(shareReplay({ bufferSize: 1, refCount: true }));
    }

    return (this.assetsStorage[key] as Observable<any>).pipe(take(1));
  }
}
